import { InteractionRequiredAuthError, PublicClientApplication } from "@azure/msal-browser";

export const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
export const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
export const authDisabled = import.meta.env.VITE_AUTH_DISABLED === "true";
export const livePreviewEnabled = import.meta.env.VITE_LIVE_PREVIEW === "true";
export const photoLibraryEnabled = import.meta.env.VITE_PHOTO_LIBRARY_ENABLED === "true";
export const workflowConfig = Object.freeze({
  enabled: import.meta.env.VITE_WORKFLOW_ENABLED === "true",
  apiUrl: String(import.meta.env.VITE_PROFILE_API_URL || "").replace(/\/$/, ""),
  scope: String(import.meta.env.VITE_PROFILE_API_SCOPE || ""),
});
export const workflowEnabled = Boolean(workflowConfig.enabled && workflowConfig.apiUrl && workflowConfig.scope);

export const reviewerPreviewSandboxConfig = Object.freeze({
  enabled: import.meta.env.VITE_REVIEWER_PREVIEW_SANDBOX === "true",
  apiUrl: String(import.meta.env.VITE_REVIEWER_PREVIEW_API_URL || "").replace(/\/$/, ""),
});
export const reviewerPreviewSandboxEnabled = Boolean(
  reviewerPreviewSandboxConfig.enabled && reviewerPreviewSandboxConfig.apiUrl,
);

export const isAuthConfigured = Boolean(
  tenantId &&
    clientId &&
    clientId !== "replace-with-application-client-id",
);

export const msal = isAuthConfigured
  ? new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
      },
    })
  : null;

export const loginRequest = {
  scopes: ["openid", "profile", "email", ...(workflowConfig.scope ? [workflowConfig.scope] : [])],
  prompt: "select_account",
};

export async function getWorkflowAccessToken(account) {
  if (!workflowEnabled) throw new Error("The approval workflow has not been enabled by Cloud Team.");
  if (!msal || !account) throw new Error("Sign in with your Rawabi Microsoft account first.");
  const request = { account, scopes: [workflowConfig.scope] };
  try {
    const result = await msal.acquireTokenSilent(request);
    return result.accessToken;
  } catch (error) {
    if (!(error instanceof InteractionRequiredAuthError)) throw error;
    const result = await msal.acquireTokenPopup(request);
    return result.accessToken;
  }
}
